export default __webpack_public_path__ + "static/media/total.47b8dfdf.png";